export const isHistorySwipeDisabled = (value) =>
  String(value || "").trim().toLowerCase() === "true";

export const applyHistorySwipeSetting = (root, disabled) => {
  root.classList.toggle("disable-history-swipe", disabled);
  return () => root.classList.remove("disable-history-swipe");
};
